<script>
  const onFB=()=>{
    window.open("https://www.facebook.com/Untangl-Eyewear-110514594873173", '_blank');
  }
</script>
<div class="flex flex-col justify-end w-full h-36 m-2">
  <hr class="mb-3"/>
  <div>
    <span class="p-2 m-2">Men</span>
    <span class="p-2 m-2">Women</span>
    <span class="p-2 m-2">Glasses</span>
    <span class="p-2 m-2">Lenses</span>
    <span class="p-2 m-2">Sunglasses</span>
    <span>
        <img on:click={onFB} class="w-12 p-2 m-2 cursor-pointer" src="img/facebook.png" alt="facebook"/>
    </span>
  </div>
  <span class="p-2 m-2">© Untangl 2022</span>
</div>